import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatINR(amount) {
  const n = Number(amount || 0);
  return "₹" + n.toLocaleString("en-IN", { maximumFractionDigits: 2 });
}

// Compact Indian currency for tight spaces (₹2.4L, ₹1.2Cr, ₹8K).
export function formatINRShort(amount) {
  const v = Number(amount) || 0;
  if (v >= 1e7) return `₹${(v / 1e7).toFixed(v % 1e7 === 0 ? 0 : 2)}Cr`;
  if (v >= 1e5) return `₹${(v / 1e5).toFixed(v % 1e5 === 0 ? 0 : 1)}L`;
  if (v >= 1e3) return `₹${Math.round(v / 1e3)}K`;
  return `₹${Math.round(v)}`;
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

// Display any date (ISO 'YYYY-MM-DD' or full ISO datetime) as DD/MM/YYYY.
export function formatDate(value) {
  if (!value) return "";
  const s = String(value);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  const d = new Date(s);
  if (!isNaN(d.getTime())) {
    const p = (n) => String(n).padStart(2, "0");
    return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}`;
  }
  return s;
}

// Display a date AND time (DD/MM/YYYY HH:MM). Accepts epoch milliseconds
// (e.g. Gmail internalDate) or an ISO datetime string.
export function formatDateTime(value) {
  if (value === null || value === undefined || value === "") return "";
  let d;
  if (typeof value === "number") d = new Date(value);
  else if (/^\d+$/.test(String(value))) d = new Date(Number(value));
  else d = new Date(String(value));
  if (isNaN(d.getTime())) return formatDate(value);
  const p = (n) => String(n).padStart(2, "0");
  let h = d.getHours();
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}, ${p(h)}:${p(d.getMinutes())} ${ampm}`;
}
